import { Box, Button, Typography } from "@mui/material";
import { Link } from "react-router-dom";

import { formConfirmationData } from "@/utils/staticData/fleetInquiry";

import { FormTitle, ConfirmationCard } from "../components";
import Logo from "@/components/UI-Kit/Logo";

const Confirmation = () => {
  return (
    <Box
      maxWidth={662}
      mx="auto"
      sx={{
        display: "flex",
        flexDirection: "column",
        justifyContent: "space-between",
        flexGrow: 1,
      }}
    >
      <Box mb={10}>
        {/* Logo */}
        <Box mb={9.75} textAlign="center" display={{ xs: "none", md: "block" }}>
          <Logo type="dark" width={204} height={38} />
        </Box>

        <FormTitle
          title="All is well, we received your request!"
          subtitle="Thank you for choosing Trackmate! We're excited to embark on this fleet management journey with you."
        />

        <Typography
          variant="h6"
          component="p"
          color={{ xs: "#282828", md: "#585858" }}
          mb={{ xs: 3.75, md: 5.25 }}
          ml={{ xs: 3.5, md: 8 }}
        >
          What’s next?
        </Typography>

        {/* Next steps */}
        <Box display="flex" flexDirection="column" gap={{ xs: 4, md: 7.75 }}>
          {formConfirmationData.map((item, index) => (
            <ConfirmationCard key={index} {...item} />
          ))}
        </Box>
      </Box>

      <Button variant="contained" type="button" component={Link} to="/">
        Back to home
      </Button>
    </Box>
  );
};

export default Confirmation;
